module.exports = __webpack_public_path__ + "img/ValleeSudDragLocation.cb5e04f0.svg";